/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Helmet } from 'react-helmet-async'
import pkg from '../../../package.json'
import { Title, TitleProps } from '@mantine/core'

export type PageTitleProps = TitleProps & {
  title: string
}

/**
 * Returns the page title.
 * @param title
 */
function getPageTitle (title?: string): string {
  return title ? `${title} - ${pkg.name}` : pkg.name
}

function PageTitle (props: PageTitleProps) {
  const { title, ...others } = props
  return (
    <Title {...others}>
      <Helmet>
        <title>{getPageTitle(title)}</title>
      </Helmet>
      {title}
    </Title>
  )
}

export default PageTitle
